export class breadcrumb {
  public label: string;
  public url: string;

  constructor(label: string, url: string) {
      this.label = label;
      this.url = url;
    }   
}
